import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { calculateMultiSegmentForecast, updateMultiSegmentForecast } from '../helpers/calculateForecast';

import { deleteTypeCurveApi, deleteTypeCurveParamsApi, getTypeCurveParamsApi, getTypeCurvesApi, loadTypeCurveAPI, saveTypeCurveApi } from '../api/typeCurveAPI';

const initialState = {
  byId: {
  },
  allIds: [],
  currentTypeCurveId: ""
};

export const getTypeCurves = createAsyncThunk(
  'typeCurves/getTypeCurves',
  async (payload, { rejectWithValue }) => {
    try {
      const email = payload?.email;
      const currentTypeCurveId = payload?.currentTypeCurveId;
      const typeCurves = await getTypeCurvesApi(email);
      return { typeCurves, currentTypeCurveId };
    } catch (error) {
      return rejectWithValue(payload.user);
    };
  }
);

export const deleteTypeCurve = createAsyncThunk(
  'typeCurves/deleteTypeCurve',
  async (payload, { getState }) => {
    try {
      const state = getState();
      const email = state?.user?.value?.email;

      await deleteTypeCurveApi(payload.typeCurveId, email);
      return { typeCurveId: payload.typeCurveId };
    } catch (error) {
      return false;
    };
  }
);

export const getTypeCurveParams = createAsyncThunk(
  'typeCurves/getTypeCurveParams',
  async (payload, { rejectWithValue }) => {
    try {
      let well = {...payload.well};
      if (well) {
        const params = await getTypeCurveParamsApi(well?.id, well?.name);
        well.params = params;

        const fluids = Object.keys(well.params);
        for (let fluid of fluids) {
          if (Object.keys(well.params?.[fluid])?.length > 0) {

            const {newFluidParams, forecast, eur} = await calculateMultiSegmentForecast(well, fluid);
           
            well.params = {...well.params, [fluid]: newFluidParams};
            let wellForecast = {...well.forecast};
            wellForecast.byFluid = {...wellForecast.byFluid, [fluid]: forecast};
            well.forecast = wellForecast;
            let wellEur = {...well.eur};
            wellEur.byFluid = {...wellEur.byFluid, [fluid]: eur};
            well.eur = wellEur;
          };
        };
        return well;
      };

    } catch (error) {
      return rejectWithValue(payload?.well?.id);
    };
  }
);

export const getTypeCurveForecast = createAsyncThunk(
  'typeCurves/getTypeCurveForecast',
  async (typeCurve, { rejectWithValue }) => {
    try {
      let well = {...typeCurve};

      if (well) {
        // const fluids = ['oil', 'gas', 'condensate'];
        const fluids = well?.production?.fluids || (well?.production?.byFluid && Object.keys(well?.production?.byFluid)) || [];

        if (!fluids?.length > 0) return;

        for (let fluid of fluids) {
          if (well.params?.[fluid] && Object.keys(well.params?.[fluid])?.length > 0) {

            const {newFluidParams, forecast, eur} = await calculateMultiSegmentForecast(well, fluid);
           
            well.params = {...well.params, [fluid]: {...newFluidParams, eur: {cutoff: well.params?.cutoff, value: eur?.p50?.cumVolume}}};
            let wellForecast = {...well.forecast};
            wellForecast.byFluid = {...wellForecast.byFluid, [fluid]: forecast};
            well.forecast = wellForecast;
            let wellEur = {...well.eur};
            wellEur.byFluid = {...wellEur.byFluid, [fluid]: eur};
            well.eur = wellEur;
          };
        };
        return well;
      };

    } catch (error) {
      console.log(error);
      return rejectWithValue(typeCurve?.id);
    };
  }
);

export const updateTypeCurveForecast = createAsyncThunk(
  'typeCurves/updateTypeCurveForecast',
  async (payload, { rejectWithValue }) => {
    try {
      let well = {...payload.well};
      const fluid = payload.fluid;
      const param = payload.param;
      const value = payload.value;
      const { newFluidParams, forecast, eur } = await updateMultiSegmentForecast(well, fluid, param, value, 'typeCurve');
      
      well.params = {...well.params, [fluid]: newFluidParams};
      if (param === 'cutoff') well.params.cutoff = value;
      well.forecast = {...well.forecast, byFluid: {...well.forecast.byFluid, [fluid]: forecast}};
      well.eur = {...well.eur, byFluid: {...well.eur.byFluid, [fluid]: eur}};

      return well;
    } catch (error) {
      return rejectWithValue(payload?.well?.id);
    };
  }
);

// export const updateCutoffTypeCurve = createAsyncThunk(
//   'typeCurves/updateCutoffTypeCurve',
//   async (payload, { rejectWithValue }) => {
//     try {
//       let well = {...payload.well};
//       const fluid = payload.fluid;
//       const cutoff = payload.cutoff;

//       const { newFluidParams, forecast, eur } = await updateMultiSegmentForecast(well, fluid, 'cutoff', cutoff);

//       well.params = {...well.params, cutoff: cutoff};
//       well.eur = {...well.eur, byFluid: {...well.eur.byFluid, [fluid]: eur}};

//       return well;
//     } catch (error) {
//       return rejectWithValue(payload?.well?.uwi);
//     };
//   }
// );

export const saveTypeCurve = createAsyncThunk(
  'typeCurves/saveTypeCurve',
  async (typeCurve, { rejectWithValue, getState }) => {
    try {

      const state = getState();
      const email = state?.user?.value?.email;

      const { success, date } = await saveTypeCurveApi(typeCurve, email);

      return { typeCurve: typeCurve, success: success, date: date };
    } catch (err) {
      return rejectWithValue([], err);
    };
  }
);

export const saveTypeCurveParams = createAsyncThunk(
  'typeCurves/saveTypeCurveParams',
  async (typeCurve, { rejectWithValue, getState }) => {
    try {

      const state = getState();
      const email = state?.user?.value?.email;

      const { success, date } = await saveTypeCurveApi(typeCurve, email);

      return { typeCurve: typeCurve, success: success, date: date };
    } catch (err) {
      return rejectWithValue([], err);
    };
  }
);

export const deleteTypeCurveParams = createAsyncThunk(
  'typeCurves/deleteTypeCurveParams',
  async (payload, { rejectWithValue }) => {
    try {

      const success = await deleteTypeCurveParamsApi(payload.typeCurveId, payload.email);
      return success;
      
    } catch (err) {
      return rejectWithValue([], err);
    };
  }
);

export const loadTypeCurve = createAsyncThunk(
  'typeCurves/loadTypeCurve',
  async (payload, { rejectWithValue }) => {
    try {
      const typeCurveLocation = payload.location;
      const typeCurveId = payload.typeCurveId;
      const userEmail = payload.email;
      if (typeCurveLocation && typeCurveId && userEmail) {
        const result = await loadTypeCurveAPI(typeCurveLocation, typeCurveId, userEmail);
        return {...result, public: false, createdBy: userEmail};
      };
    } catch (error) {
      return rejectWithValue(payload?.id);
    };
  }
);

export const typeCurveSlice = createSlice({
  name: 'typeCurves',
  initialState,
  reducers: {
    addTypeCurve: (state, action) => {
      try {
        const id = action.payload.id;
        state.byId[id] = action.payload;
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentTypeCurveId = id;
      } catch (error) {
        return;
      };
    },
    toggleCheckTypeCurve: (state, action) => {
      try {
        const typeCurveId = action.payload.typeCurveId;
        if (!state?.byId?.[typeCurveId]) return;

        if (!state.byId[typeCurveId].checked) {
          state.byId[typeCurveId].checked = true;  
        } else {
          state.byId[typeCurveId].checked = false;  
        };
      } catch (error) {
        return;
      };
    },
    toggleCheckAllTypeCurves: (state, action) => {
      try {
        const typeCurveIds = action.payload.typeCurveIds;
        typeCurveIds?.forEach(id => {
          state.byId[id].checked = true;
        });
      } catch (error) {
        return;
      };
    },
    toggleUncheckAllTypeCurves: (state, action) => {
      try {
        const typeCurveIds = action.payload.typeCurveIds;
        typeCurveIds?.forEach(id => {
          state.byId[id].checked = false;
        });
      } catch (error) {
        return;
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTypeCurveForecast.fulfilled, (state, action) => {
      try {
        const id = action?.payload?.id;
        if (!id) return;
        state.byId[id] = action.payload;
        state.byId[id].checked = true;
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentTypeCurveId = id;
      } catch (error) {
        console.log(error);
      };
    })
    builder.addCase(updateTypeCurveForecast.fulfilled, (state, action) => {
      try {
        const id = action.payload.id;
        state.byId[id] = action.payload;
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentTypeCurveId = id;
      } catch (error) {
        return;
      };
    })
    builder.addCase(getTypeCurves.fulfilled, (state, action) => {
      try {
        const typeCurves = action?.payload?.typeCurves;
        const currentTypeCurveId = action?.payload?.currentTypeCurveId;
        if (typeCurves?.length > 0) {
          for (let typeCurve of typeCurves) {
            state.byId[typeCurve.id] = typeCurve;
            if (state.allIds.indexOf(typeCurve.id) === -1) state.allIds.push(typeCurve.id);
          };
          state.currentTypeCurveId = currentTypeCurveId || state.allIds?.[state.allIds?.length - 1];
        };
      } catch (error) {
        return;
      };
    })
    builder.addCase(getTypeCurveParams.fulfilled, (state, action) => {
      try {
        const id = action.payload.id;
        state.byId[id] = action.payload;
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentTypeCurveId = id;
      } catch (error) {
        return;
      };
    })
    builder.addCase(saveTypeCurve.fulfilled, (state, action) => {
      try {
        if (action.payload.typeCurve) {
          const typeCurve = action.payload.typeCurve;
          state.byId[typeCurve.id] = typeCurve;
          state.currentTypeCurveId = typeCurve.id;
        };
      } catch (error) {
        return;
      };
    })
    builder.addCase(saveTypeCurveParams.fulfilled, (state, action) => {
      try {
        const typeCurve = action.payload.typeCurve;
        state.byId[typeCurve.id] = typeCurve;
      } catch (error) {
        return;
      };
    })
    builder.addCase(deleteTypeCurve.fulfilled, (state, action) => {
      try {
        const typeCurveId = action.payload.typeCurveId;
        delete state.byId[typeCurveId];
        state.allIds = state.allIds.filter(id => id !== typeCurveId);
      } catch (error) {
        return;
      };
    })
    builder.addCase(loadTypeCurve.fulfilled, (state, action) => {
      try {
        if (action.payload) {
          let typeCurve = {...action.payload};
          
          state.byId[typeCurve.id] = typeCurve;
  
          if (state.allIds.indexOf(typeCurve.id) === -1) {
            state.allIds.push(typeCurve.id);
          };
          state.currentTypeCurveId = typeCurve.id;
        };
      } catch (error) {
        return;
      };
    })
  },
});

export const { addTypeCurve, toggleCheckTypeCurve, toggleCheckAllTypeCurves, toggleUncheckAllTypeCurves } = typeCurveSlice.actions;

export const selectTypeCurves = (state) => state.typeCurves;

export default typeCurveSlice.reducer;